<script>
  const toEuro = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  });

  function addZero(numb) {
    return numb < 10 ? "0" + numb : numb;
  }

  function timestampToDate(timestamp) {
    let dateObj = new Date( timestamp );
    return `${addZero(dateObj.getDate())}.${addZero(dateObj.getMonth() + 1)}.`;
  }

  export let order;
</script>
  
  
  <div class="singleMilkOption">
    <div class="milkOptionContent">
        <div>Bestellung vom {timestampToDate(order.createdAt)}</div>
        <div>Für {order.childName.split(" ")[0]}<br/>aus der {order.class}</div>
        <div>{toEuro.format(order.totalSum)} 
          {#if order.status == "ordered"}
            <div>Zahlung vorgemerkt</div>
          {:else if order.status == "belowThreshold"}
            <div>storniert</div>
          {:else if order.status == "initiated"}
            <div>Zahlung angewiesen</div>
          {:else if order.status == "success"}
            <div>bereits bezahlt</div>
          {:else if order.status == "failed"}
            <div>Zahlung fehlgeschlagen</div>
          {/if}
        </div>
    </div>
  </div>
  
  
  <style>
    .singleMilkOption {
      user-select: none;
      border-radius: 10px;
      height: 120px;
      width: 210px;
      margin: 10px 10px;
      box-shadow: 0 0 8px rgba(0, 0, 0, 0.12);
      border: 0 solid #63b4d1;
      transform: scale(1) translateY(1px);
      transition: transform 0.15s ease-in-out, box-shadow 0.25s ease-in-out,
        background 0.1s ease-in-out, border 0.1s ease-in-out,
        color 0.1s ease-in-out;
    }
  
    .singleMilkOption > div.milkOptionContent {
      opacity: 0.75;
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      flex-wrap: nowrap;
      padding: 10px 15px;
      justify-content: space-between;
      align-items: center;
    }

    .milkOptionContent > div:nth-child(1) {
      font-size: 13px;
      text-align: right;
      width: 100%;
      font-weight: 600;
    }

    .milkOptionContent > div:nth-child(3) {
      display: flex;
      align-items: flex-end;
      font-size: 17px;
      text-align: left;
      width: 100%;
      font-weight: 600;
    }

    .milkOptionContent > div:nth-child(2) {
      font-size: 20px;
      color: #3AA1C3;
      line-height: 19px;
      font-weight: 600;
    }

    .milkOptionContent > div:nth-child(3) > div {
      font-size: 10px;
      font-weight: 300;
      font-style: italic;
      padding-left: 5px;
      padding-bottom: 3px;
    }
  </style>
  